// @ts-nocheck
import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, get, post, ServiceResult } from "@insite/client-framework/Services/ApiService";

export interface GetUserAccountTermsApiParameter extends ApiParameter {}
export interface GetUserPriceListApiParameter extends ApiParameter {
    url: string;
}

export interface AccountTermsModel {
    currentTermsUrl?: string;
    nextTermsUrl?: string;
}
export const PRICE_LIST_ACTUAL_URL = "current/priceList/actual";
export const PRICE_LIST_NEXT_URL = "current/priceList/next";

export interface AccountPriceListResult {}

const accountsUrl = "/api/custom/accounts";

export async function getCurrentAccountTerms(parameter: GetUserAccountTermsApiParameter) {
    const accountTerms = await get<AccountTermsModel>(`${accountsUrl}/current/summary`);
    return accountTerms;
}

export async function getPriceList(
    parameter: GetUserPriceListApiParameter,
): Promise<ServiceResult<AccountPriceListResult>> {
    try {
        await post(`${accountsUrl}/${parameter.url}`);
        return {
            successful: true,
            result: {},
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        return {
            successful: false,
            errorMessage: "error",
        };
    }
}
